<script setup lang="ts">
import { useFirebaseAuth } from 'vuefire'
import { FirebaseAuthService } from '@/services/auth/firebase-auth-service'
import { AuthProvider } from '@/services/auth/auth-service'
import LoginContent from './components/LoginContent.vue'

const authStore = useAuthStore()
const firebaseAuth = useFirebaseAuth()
const router = useRouter()

definePage({
  name: '/login',
  path: '/login',
  meta: {
    allowAnonymous: true,
  },
})

onBeforeMount(async () => {
  const isAuthenticated = await authStore.isAuthenticated()
  if (isAuthenticated) {
    await router.push({ name: '/' })
  }
})

const loginFailed = ref(false)
const isProcessing = ref(false)

async function handleSubmit(credentials: {
  email: string,
  password: string 
}) {
  loginFailed.value = false
  isProcessing.value = true

  const firebaseAuthService = await authStore.getAuthService(AuthProvider.Firebase, FirebaseAuthService, firebaseAuth)

  try {
    await firebaseAuthService.login(credentials.email, credentials.password)
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (_) {
    loginFailed.value = true
    isProcessing.value = false

    return
  }

  await router.push({ name: '/' })
}
</script>

<template>
  <LoginContent :login-failed="loginFailed" :is-processing="isProcessing" @submit="handleSubmit" />
</template>
